import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Charts } from "./charts.model";

@Injectable({
  providedIn: 'root'
})
export class ChartService {

  public selectedCharts: Charts;

  constructor(private httpClient: HttpClient) {
  }

  getBaseUrl() {
    return environment.baseUrl;
  }

  FetchCustomerChartsList() {

    this.selectedCharts = new Charts();
    this.selectedCharts.IsCustomersChart = true;
    this.selectedCharts.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCharts.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCharts.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.selectedCharts.FromDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"]
    this.selectedCharts.ToDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = this.selectedCharts;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Charts/FetchList', body, { headers: headers });
  }

  FetchLoanChartsList() {

    this.selectedCharts = new Charts();
    this.selectedCharts.IsLoanChart = true;
    this.selectedCharts.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedCharts.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedCharts.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.selectedCharts.FromDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"]
    this.selectedCharts.ToDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = this.selectedCharts;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Charts/FetchList', body, { headers: headers });
  }

}
